export function getMessageAuthor(message, application, user) {
  const senderId = message?.senderId || message?.createdBy;
  const selfIds = [user?._id, user?.userId].filter(Boolean);
  const isCurrentUser = !!senderId && selfIds.includes(senderId);
  const suppliedName = message?.createdName?.trim();
  let name;
  if (isCurrentUser) {
    name = [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() || suppliedName || "You";
  } else if (senderId && senderId === application?.recruiterId) {
    name = application?.recruiterName?.trim() || suppliedName || "Recruiter";
  } else if (senderId && senderId === application?.referralId) {
    name = application?.referralName?.trim() || suppliedName || "Referral";
  } else {
    name = suppliedName || "Participant";
  }
  return { name, isCurrentUser };
}
